import CloseIcon from "../images/icons/white-close.svg"
export default function Modal(props) {
    return (
        <div className={"fixed top-0 left-0 z-10 flex flex-col justify-center place-items-center h-screen w-screen bg-dark-blue/40 backdrop-blur"}>
            <div className={"w-full mx-auto max-w-screen-lg bg-gray-500/50 flex flex-row place-items-center justify-between"}>
                <h2 className={"flex-grow font-bold px-2"}>{props.heading}</h2>
                <button className={"px-5 py-2 rounded bg-dark-blue text-white m-2 hover:text-yellow transition"} onClick={props.closeEvent}>
                    <img src={CloseIcon} alt='Close Image' className='h-7'/>
                </button>
            </div>
            <div>
                {props.children}
            </div>
        </div>
    );
}
